import {
  GET_UNITS,
  GET_UNITS_SUCCESS,
  GET_UNITS_FAIL,
  GET_UNIT_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const Unit = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_UNITS:
      return {
        ...state,
        loading: true,
      };
    case GET_UNITS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_UNIT_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_UNITS_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default Unit;
